'use client';

import React from 'react';

import styles from './styles.module.css';

import { ModuleHeader, ModuleHeaderSize } from '@/components/ModuleHeader';
import { ProductImpressionHandler } from '@/components/ProductImpressionHandler';
import { ScrollableItemRow } from '@/components/ScrollableItemRow';
import { SimilarItemsProductCard } from '@/components/SimilarItems/SimilarItemsProductCard';
import { type ModuleName } from '@/modules/impressions/types';
import { type SimilarProduct } from '@/modules/similar/aliases';

type Props = {
  title: string;
  products: SimilarProduct[];
  itemsPerRow: number;
  scrollableItemRowClassName?: string;
  minItemWidth?: number;
  headerButton?: React.ReactNode;
  moduleName: ModuleName;
  onProductClick?: (product: SimilarProduct, index: number) => void;
  showBrandName?: boolean;
};

export function SimilarItems({
  title,
  products,
  scrollableItemRowClassName,
  itemsPerRow,
  minItemWidth,
  headerButton,
  moduleName,
  onProductClick = () => null,
  showBrandName = true,
}: Props) {
  return (
    <section>
      <ModuleHeader
        title={title}
        size={ModuleHeaderSize.Small}
        className={styles.header}
      >
        {headerButton}
      </ModuleHeader>
      <ScrollableItemRow
        itemsPerRow={itemsPerRow}
        minItemWidth={minItemWidth}
        className={scrollableItemRowClassName}
      >
        {products.map((product, index) => {
          return (
            <li key={product.id}>
              <ProductImpressionHandler
                index={index}
                isLastItem={index === products.length - 1}
                pageNumber={1}
                moduleName={moduleName}
              >
                <SimilarItemsProductCard
                  id={product.id}
                  slug={product.slug}
                  pricing={product.pricing}
                  isBoosted={product.is_boosted}
                  product={product}
                  onClick={(product) => onProductClick(product, index)}
                  showBrandName={showBrandName}
                />
              </ProductImpressionHandler>
            </li>
          );
        })}
      </ScrollableItemRow>
    </section>
  );
}
